import { Modal, ModalProps } from "antd";
import styled, { css } from "styled-components";

const mobileStyles = css`
  position: fixed;
  top: 0;
  left: 0;

  .ant-modal-content {
    height: 100vh;
    width: 100vw;
  }
`;

const desktopStyles = css``;

interface ResponsiveModalProps extends ModalProps {
  $mobile?: boolean;
}

export const ResponsiveModal = styled(Modal)<ResponsiveModalProps>`
  ${({ $mobile }) => ($mobile === true ? mobileStyles : desktopStyles)}
`;
